import {
    mapState,
    mapActions
} from 'vuex'
import viewName from '../constant.js'
import {
    sendBoundMsg
} from '@/models/appInfo'
// import {
//     getLoginInfo,
// } from '../../utils/loginInfo'
export default {
    name: viewName.bindingResult,
    components: {},
    data () {
        return {
            boundType: '', // bound绑定过跳转 已经绑定，  刚绑定完成:binding
            phone_number: '', // 获取用户信息的本地缓存的
        }
    },
    computed: {
        ...mapState({})
    },
    created () {
        this.boundType = this.$route.query.boundType

        this.setAppClass({
            isAppend: false,
            className: 'bgWhiteColor'
        })

        sendBoundMsg()
    },
    activated () {},
    mounted () {},
    methods: {
        ...mapActions(['setAppClass']),
        closeYC () {
            wx.closeWindow()
        }
    },
    destroyed () {}
}
